import Model from "../../../../models/Model.js";
import SieFile from "./SieFile.js";

/**
 * Represent a sequence of SieFile models.
 *
 * @param {SieFile[]} sieFiles - .
 */
export default class SieFiles extends Model {
	constructor({ sieFiles = [] } = {}) {
		super(...arguments);

		this._sieFiles = sieFiles;
	}

	isEmpty() {
		return this._sieFiles.length === 0;
	}

	getSortedSieFiles({ predicate = () => true } = {}) {
		const sieFiles = this._sieFiles.filter((sieFile) => predicate(sieFile));

		sieFiles.sort((sieFile1, sieFile2) => sieFile1.compare(sieFile2));

		return sieFiles;
	}

	*[Symbol.iterator]() {
		yield* this._sieFiles;
	}

	static materializeAll(data, context) {
		return this.buildFrom({
			sieFiles: SieFile.materializeAll(data, context),
		});
	}
}
